import api from 'api/apiInstance';
import type { RequestConfig } from 'api/types';

export interface ClientMetaDocumentVaultItemsGetResponse {
  has_unread_document_vault_items: number;
}

export function clientMetaDocumentVaultItemsApi(path: string) {
  return {
    path,
    GET: (config?: RequestConfig) => api.get<ClientMetaDocumentVaultItemsGetResponse>(path, config),
  };
}
